export default function JsonIcon(): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" data-testid="jsonIcon">
      <g id="doc_icon" transform="translate(1 7)">
        <rect
          id="Rectangle_4360"
          data-name="Rectangle 4360"
          width="24"
          height="24"
          transform="translate(-1 -7)"
          opacity="0"
        />
        <rect
          id="Rectangle_4250"
          data-name="Rectangle 4250"
          width="22"
          height="22"
          transform="translate(0 -6)"
          opacity="0"
        />
        <g id="Path_25073" data-name="Path 25073" transform="translate(2 -6)" fill="#f2f2f2">
          <path
            d="M 17.5 21.5 L 0.5 21.5 L 0.5 0.5 L 11.79290008544922 0.5 L 17.5 6.207099914550781 L 17.5 21.5 Z"
            stroke="none"
          />
          <path
            d="M 1 1 L 1 21 L 17 21 L 17 6.414219856262207 L 11.58578014373779 1 L 1 1 M 0 0 L 12 0 L 18 6 L 18 22 L 0 22 L 0 0 Z"
            stroke="none"
            fill="gray"
          />
        </g>
        <g id="Path_25072" data-name="Path 25072" transform="translate(14 -6)" fill="none">
          <path d="M-1,0H0L6,6V7H-1Z" stroke="none" />
          <path
            d="M 0 1.414219856262207 L 0 6 L 4.585780143737793 6 L 0 1.414219856262207 M -1 0 L 0 0 L 6 6 L 6 7 L -1 7 L -1 0 Z"
            stroke="none"
            fill="gray"
          />
        </g>
        <g
          id="Rectangle_4275"
          data-name="Rectangle 4275"
          transform="translate(0 4)"
          fill="#f2f2f2"
          stroke="gray"
          strokeWidth="1"
        >
          <rect width="23" height="9" stroke="none" />
          <rect x="0.5" y="0.5" width="22" height="8" fill="none" />
        </g>
        <path
          id="Union_39"
          data-name="Union 39"
          d="M17623-1400v-1h1l0,1a1,1,0,0,0,1,1,1,1,0,0,0,1-1h0v-3h1v2h.006v1a2,2,0,0,1-2,2A2,2,0,0,1,17623-1400Z"
          transform="translate(-17620.998 1409)"
          fill="gray"
        />
        <g
          id="Rectangle_4400"
          data-name="Rectangle 4400"
          transform="translate(12 6)"
          fill="none"
          stroke="gray"
          strokeWidth="1"
        >
          <rect width="4" height="5" rx="1" stroke="none" />
          <rect x="0.5" y="0.5" width="3" height="4" rx="0.5" fill="none" />
        </g>
        <path
          id="Union_38"
          data-name="Union 38"
          d="M17598-1112v-1h3v-1h-2a1,1,0,0,1-1-1v-1a1,1,0,0,1,1-1h3v1h-3v1h2v0a1,1,0,0,1,1,1v1a1,1,0,0,1-1,1Z"
          transform="translate(-17591 1123.002)"
          fill="gray"
        />
        <rect
          id="Rectangle_4403"
          data-name="Rectangle 4403"
          width="1"
          height="5"
          transform="translate(20 6)"
          fill="gray"
        />
        <rect
          id="Rectangle_4404"
          data-name="Rectangle 4404"
          width="1"
          height="5"
          transform="translate(17 6)"
          fill="gray"
        />
        <path id="Path_25110" data-name="Path 25110" d="M0,0H1L4,5H3Z" transform="translate(17 6)" fill="gray" />
      </g>
    </svg>
  )
}
